module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    // API_URL: "https://api-iot.atapteknologi.id",
    API_URL: "https://api-iot.atapteknologi.id",
    // API_URL: "http://api.pms.atapteknologi.id",
    // API_URL: "https://api-iot.atapteknologi.id",
    SSO_URL: "https://sso.atapteknologi.id",
    MEDIA_URL: "https://drive.atapteknologi.id",
    SMS_URL: "https://api-sms.atapteknologi.id",
    ERP_URL: "https://api-erp.atapteknologi.id",
  },
};
